import { render, staticRenderFns } from "./UserTagsAdd.vue?vue&type=template&id=2bf69b16&"
import script from "./UserTagsAdd.vue?vue&type=script&lang=js&"
export * from "./UserTagsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports